import type { CSSProperties, FC } from 'react';
import type { TeacherProfile } from '../types';
import { BookOpenIcon, ExternalLinkIcon } from './TeacherIcons';

interface TeacherOfficialSourcesOverlayProps {
  profile?: TeacherProfile | null;
  onBackToCabinet: () => void;
  onOpenCourseWorkspace: () => void;
}

interface SourceLink {
  title: string;
  category: string;
  description: string;
  url: string;
}

const SOURCES: SourceLink[] = [
  {
    title: 'Официальный портал ЕНУ имени Л.Н. Гумилева',
    category: 'Университет',
    description: 'Главный веб-ресурс Евразийского национального университета: структура, факультеты, новости.',
    url: 'https://enu.kz/',
  },
  {
    title: 'Академическая информационная система Platonus ENU',
    category: 'Учебный процесс',
    description: 'Электронный деканат, официальные ведомости, расписание и фиксация академических достижений.',
    url: 'https://platonus.enu.kz/',
  },
  {
    title: 'Научная библиотека «Отырар» ЕНУ',
    category: 'Библиотечные ресурсы',
    description: 'Электронный каталог, доступ к базам Scopus, Web of Science, SpringerLink и диссертационному фонду.',
    url: 'https://lib.enu.kz/',
  },
  {
    title: 'Департамент по академическим вопросам ЕНУ',
    category: 'Регламенты и стандарты',
    description: 'Правила академической честности, положения об аттестации, формы силлабусов и календарный план.',
    url: 'https://enu.kz/ru/academics/',
  },
  {
    title: 'Институт непрерывного образования и повышения квалификации',
    category: 'Квалификация',
    description: 'Курсы педагогического мастерства, цифровые компетенции преподавателя и сертификационные программы.',
    url: 'https://enu.kz/ru/cooperation/',
  },
];

export const TeacherOfficialSourcesOverlay: FC<TeacherOfficialSourcesOverlayProps> = ({
  profile,
  onBackToCabinet,
  onOpenCourseWorkspace,
}) => {
  return (
    <div className="cab-shell cab-shell--wide">
      <div className="cab-top">
        <div className="cab-top-left">
          <div>
            <small>Кабинет преподавателя</small>
            <h2>Официальные источники ENU</h2>
            <p>Кабинеты, маршруты, ответственные и подтверждённые процедуры ЕНУ.</p>
          </div>
        </div>
        <div className="cab-top-actions">
          <button type="button" className="cab-btn" onClick={onOpenCourseWorkspace}>
            <BookOpenIcon className="w-4 h-4" />
            Учебный процесс
          </button>
          <button type="button" className="cab-btn primary" onClick={onBackToCabinet}>
            В кабинет
          </button>
        </div>
      </div>

      <div className="cab-body">
        <article className="cabinet-card" style={{ ['--accent' as string]: '#9e80ff', marginBottom: 14 }}>
          <strong>{profile?.full_name || '—'}</strong>
          <p style={{ margin: '6px 0 0', fontSize: 12, color: '#8faebb' }}>
            {profile?.department || 'Кафедра казахского языкознания'} ·{' '}
            {profile?.university || 'Евразийский национальный университет имени Л.Н. Гумилева'}
          </p>
        </article>

        <div className="cabinet-grid2">
          {SOURCES.map((source) => (
            <a
              key={source.title}
              href={source.url}
              target="_blank"
              rel="noreferrer"
              className="cabinet-card"
              style={{ ['--accent' as string]: '#9e80ff', textDecoration: 'none', color: 'inherit' }}
            >
              <div className="cabinet-actions" style={{ marginBottom: 8, alignItems: 'center' }}>
                <span className="cabinet-badge" style={{ '--badge': '#9e80ff' } as CSSProperties}>
                  {source.category}
                </span>
                <ExternalLinkIcon className="w-4 h-4" />
              </div>
              <h3>{source.title}</h3>
              <p>{source.description}</p>
              <div className="cabinet-actions" style={{ color: '#9e80ff', fontWeight: 800, fontSize: 12 }}>
                <span>Перейти на ресурс</span>
                <span aria-hidden="true">→</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
